export default {
  sklopovi: {
    _1_1_19_0: {
      u: 1.26,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_1_25_0: {
      u: 1.19,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_1_29_0: {
      u: 1.14,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_1_38_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_10_0_0: {
      u: 0.95,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _1_11_0_0: {
      u: 1.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_12_0_0: {
      u: 1.65,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _1_13_25_0: {
      u: 1.61,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_14_10_0: {
      u: 2.2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_10_3: {
      u: 0.85,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_10_5: {
      u: 0.6,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_10_7: {
      u: 0.45,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_12_5: {
      u: 0.52,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_12_8: {
      u: 0.38,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_19_3: {
      u: 0.67,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_19_5: {
      u: 0.47,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_25_3: {
      u: 0.64,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_15_29_5: {
      u: 0.44,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_16_30_0: {
      u: 0.45,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_16_38_0: {
      u: 0.25,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_17_0_0: {
      u: 0.44,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_18_0_4: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_18_0_5: {
      u: 0.44,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_18_0_6: {
      u: 0.4,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_19_0_0: {
      u: 1.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_2_18_12: {
      u: 0.25,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_2_18_8: {
      u: 0.33,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_2_25_0: {
      u: 0.35,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_2_25_10: {
      u: 0.32,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_2_29_10: {
      u: 0.25,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_20_0_4: {
      u: 0.68,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_20_0_5: {
      u: 0.58,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_20_0_6: {
      u: 0.51,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_20_0_8: {
      u: 0.41,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_3_20_0: {
      u: 1.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_3_25_0: {
      u: 1.15,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_3_30_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_25_0: {
      u: 1.84,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_30_0: {
      u: 1.64,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_38_0: {
      u: 1.4,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_45_0: {
      u: 1.25,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_51_0: {
      u: 1.14,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_4_60_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_5_19_0: {
      u: 1.89,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_5_25_0: {
      u: 1.6,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_5_29_0: {
      u: 1.4,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_5_38_0: {
      u: 1.2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_6_10_3: {
      u: 0.95,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_6_19_3: {
      u: 0.8,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_6_25_5: {
      u: 0.54,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_6_29_3: {
      u: 0.71,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_6_29_5: {
      u: 0.52,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_7_0_0: {
      u: 3.4,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_8_0_5: {
      u: 0.7,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_8_0_6: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_8_0_8: {
      u: 0.4,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_9_30_0: {
      u: 2.13,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_9_50_0: {
      u: 1.55,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _1_9_60_0: {
      u: 1.37,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_1: {
      u: 5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_10: {
      u: 1.8,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_11: {
      u: 1.5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_12: {
      u: 2.8,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_13: {
      u: 2.7,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_14: {
      u: 1.7,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_15: {
      u: 1.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_16: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_17: {
      u: 3.3,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_18: {
      u: 3.1,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_19: {
      u: 2.5,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_2: {
      u: 6,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_20: {
      u: 2.2,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_21: {
      u: 1.4,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_22: {
      u: 1.1,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_23: {
      u: 4.5,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_24: {
      u: 4.1,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _10_25: {
      u: 3.2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_26: {
      u: 3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_27: {
      u: 2.8,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_28: {
      u: 2.6,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_30: {
      u: 0.9,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_29: {
      u: 1.3,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_31: {
      u: 1.1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_32: {
      u: 0.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_3: {
      u: 4.7,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _10_4: {
      u: 3.5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_5: {
      u: 3.3,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_6: {
      u: 3.1,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_7: {
      u: 3,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_8: {
      u: 2.8,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _10_9: {
      u: 2,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _13_1: {
      u: 2.5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _13_2: {
      u: 1.5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _13_3: {
      u: 5.5,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _13_4: {
      u: 1.5,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _13_5: {
      u: 3.5,
      tip_prozora: 1,
      laka_konstrukcija: false,
    },
    _13_6: {
      u: 3.3,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _13_7: {
      u: 2.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _13_8: {
      u: 0.8,
      tip_prozora: 2,
      laka_konstrukcija: false,
    },
    _13_9: {
      u: 0.85,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_1_16_0: {
      u: 3.55,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_101_16_0: {
      u: 3.55,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_102_0_0: {
      u: 0.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_103_0_0: {
      u: 2.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_104_0_0: {
      u: 1.2,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_105_0_0: {
      u: 0.85,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_106_0_0: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_106_0_12: {
      u: 0.31,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_107_20_10: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_108_20_10: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_109_0_10: {
      u: 0.29,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_2_0_0: {
      u: 0.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_3_0_0: {
      u: 2.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_4_0_0: {
      u: 1.2,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_5_0_0: {
      u: 0.85,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_6_0_0: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_6_0_12: {
      u: 0.31,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _18_7_20_10: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_8_20_10: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _18_9_0_10: {
      u: 0.29,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_1_20_0: {
      u: 1.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_10_0_0: {
      u: 0.45,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_10_0_2: {
      u: 0.87,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_10_0_3: {
      u: 0.7,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_10_0_6: {
      u: 0.46,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_11_20_2: {
      u: 0.42,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_2_0_0: {
      u: 2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_3_0_0: {
      u: 0.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_4_0_0: {
      u: 1.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_5_0_0: {
      u: 1.2,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _19_6_0_0: {
      u: 0.65,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _19_7_0_0: {
      u: 0.8,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_8_0_0: {
      u: 0.9,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_0: {
      u: 0.52,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_12: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_2: {
      u: 1.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_3: {
      u: 1.2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_6: {
      u: 0.51,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _19_9_0_8: {
      u: 0.45,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_1_50_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_1_60_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_2_25_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_2_38_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_2_45_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_2_51_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_2_60_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_3_20_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_3_25_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_3_30_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_4_20_5: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_4_25_5: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _20_4_30_5: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_1_0_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_2_0_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_3_0_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_10: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_12: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_3: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_4: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_5: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_6: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _21_4_0_8: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_1_0_0: {
      u: 3.05,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_2_0_0: {
      u: 1.3,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_3_0_0: {
      u: 1.6,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_4_16_3: {
      u: 0.96,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_5_0_0: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_5_0_12: {
      u: 0.35,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_5_0_18: {
      u: 0.2,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _5_6_15_0: {
      u: 0.85,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _7_1_0_0: {
      u: 4.05,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _7_2_20_0: {
      u: 1.92,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _7_3_0_0: {
      u: 2.2,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_4_0_0: {
      u: 1,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_4_0_10: {
      u: 0.36,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_4_0_12: {
      u: 0.3,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_4_0_5: {
      u: 0.63,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_4_0_8: {
      u: 0.55,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_5_0_0: {
      u: 0.27,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_5_0_15: {
      u: 0.25,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_5_0_30: {
      u: 0.13,
      tip_prozora: 0,
      laka_konstrukcija: true,
    },
    _7_6_0_3: {
      u: 1.05,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _7_6_0_6: {
      u: 0.5,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
    _7_6_0_7: {
      u: 0.45,
      tip_prozora: 0,
      laka_konstrukcija: false,
    },
  },
  sklopovi_grupe: {
    _1_1: {
      ima_termoizolaciju: false,
    },
    _1_2: {
      ima_termoizolaciju: true,
    },
    _1_3: {
      ima_termoizolaciju: false,
    },
    _1_4: {
      ima_termoizolaciju: false,
    },
    _1_5: {
      ima_termoizolaciju: false,
    },
    _1_6: {
      ima_termoizolaciju: true,
    },
    _1_7: {
      ima_termoizolaciju: false,
    },
    _1_8: {
      ima_termoizolaciju: true,
    },
    _1_9: {
      ima_termoizolaciju: false,
    },
    _1_10: {
      ima_termoizolaciju: false,
    },
    _1_11: {
      ima_termoizolaciju: false,
    },
    _1_12: {
      ima_termoizolaciju: false,
    },
    _1_13: {
      ima_termoizolaciju: false,
    },
    _1_14: {
      ima_termoizolaciju: false,
    },
    _1_15: {
      ima_termoizolaciju: true,
    },
    _1_16: {
      ima_termoizolaciju: false,
    },
    _1_17: {
      ima_termoizolaciju: false,
    },
    _1_18: {
      ima_termoizolaciju: true,
    },
    _1_19: {
      ima_termoizolaciju: false,
    },
    _1_20: {
      ima_termoizolaciju: true,
    },
    _5_1: {
      ima_termoizolaciju: false,
    },
    _5_2: {
      ima_termoizolaciju: false,
    },
    _5_3: {
      ima_termoizolaciju: false,
    },
    _5_4: {
      ima_termoizolaciju: true,
    },
    _5_5: {
      ima_termoizolaciju: true,
    },
    _5_6: {
      ima_termoizolaciju: false,
    },
    _7_1: {
      ima_termoizolaciju: false,
    },
    _7_2: {
      ima_termoizolaciju: false,
    },
    _7_3: {
      ima_termoizolaciju: false,
    },
    _7_4: {
      ima_termoizolaciju: true,
    },
    _7_5: {
      ima_termoizolaciju: true,
    },
    _7_6: {
      ima_termoizolaciju: true,
    },
    _10_1: {
      ima_termoizolaciju: false,
    },
    _10_2: {
      ima_termoizolaciju: false,
    },
    _10_3: {
      ima_termoizolaciju: false,
    },
    _10_4: {
      ima_termoizolaciju: false,
    },
    _10_5: {
      ima_termoizolaciju: false,
    },
    _10_6: {
      ima_termoizolaciju: false,
    },
    _10_7: {
      ima_termoizolaciju: false,
    },
    _10_8: {
      ima_termoizolaciju: false,
    },
    _10_9: {
      ima_termoizolaciju: false,
    },
    _10_10: {
      ima_termoizolaciju: false,
    },
    _10_11: {
      ima_termoizolaciju: false,
    },
    _10_12: {
      ima_termoizolaciju: false,
    },
    _10_13: {
      ima_termoizolaciju: false,
    },
    _10_14: {
      ima_termoizolaciju: false,
    },
    _10_15: {
      ima_termoizolaciju: false,
    },
    _10_16: {
      ima_termoizolaciju: false,
    },
    _10_17: {
      ima_termoizolaciju: false,
    },
    _10_18: {
      ima_termoizolaciju: false,
    },
    _10_19: {
      ima_termoizolaciju: false,
    },
    _10_20: {
      ima_termoizolaciju: false,
    },
    _10_21: {
      ima_termoizolaciju: false,
    },
    _10_22: {
      ima_termoizolaciju: false,
    },
    _10_23: {
      ima_termoizolaciju: false,
    },
    _10_24: {
      ima_termoizolaciju: false,
    },
    _10_25: {
      ima_termoizolaciju: false,
    },
    _10_26: {
      ima_termoizolaciju: false,
    },
    _10_27: {
      ima_termoizolaciju: false,
    },
    _10_28: {
      ima_termoizolaciju: false,
    },
    _10_29: {
      ima_termoizolaciju: false,
    },
    _10_30: {
      ima_termoizolaciju: false,
    },
    _10_31: {
      ima_termoizolaciju: false,
    },
    _10_32: {
      ima_termoizolaciju: false,
    },
    _13_1: {
      ima_termoizolaciju: false,
    },
    _13_2: {
      ima_termoizolaciju: false,
    },
    _13_3: {
      ima_termoizolaciju: false,
    },
    _13_4: {
      ima_termoizolaciju: false,
    },
    _13_5: {
      ima_termoizolaciju: false,
    },
    _13_6: {
      ima_termoizolaciju: false,
    },
    _13_7: {
      ima_termoizolaciju: false,
    },
    _13_8: {
      ima_termoizolaciju: false,
    },
    _13_9: {
      ima_termoizolaciju: false,
    },
    _18_1: {
      ima_termoizolaciju: false,
    },
    _18_2: {
      ima_termoizolaciju: false,
    },
    _18_3: {
      ima_termoizolaciju: false,
    },
    _18_4: {
      ima_termoizolaciju: false,
    },
    _18_5: {
      ima_termoizolaciju: false,
    },
    _18_6: {
      ima_termoizolaciju: true,
    },
    _18_7: {
      ima_termoizolaciju: true,
    },
    _18_8: {
      ima_termoizolaciju: true,
    },
    _18_9: {
      ima_termoizolaciju: true,
    },
    _18_101: {
      ima_termoizolaciju: false,
    },
    _18_102: {
      ima_termoizolaciju: false,
    },
    _18_103: {
      ima_termoizolaciju: false,
    },
    _18_104: {
      ima_termoizolaciju: false,
    },
    _18_105: {
      ima_termoizolaciju: false,
    },
    _18_106: {
      ima_termoizolaciju: true,
    },
    _18_107: {
      ima_termoizolaciju: true,
    },
    _18_108: {
      ima_termoizolaciju: true,
    },
    _18_109: {
      ima_termoizolaciju: true,
    },
    _19_1: {
      ima_termoizolaciju: false,
    },
    _19_2: {
      ima_termoizolaciju: false,
    },
    _19_3: {
      ima_termoizolaciju: false,
    },
    _19_4: {
      ima_termoizolaciju: false,
    },
    _19_5: {
      ima_termoizolaciju: false,
    },
    _19_6: {
      ima_termoizolaciju: false,
    },
    _19_7: {
      ima_termoizolaciju: false,
    },
    _19_8: {
      ima_termoizolaciju: false,
    },
    _19_9: {
      ima_termoizolaciju: true,
    },
    _19_10: {
      ima_termoizolaciju: true,
    },
    _19_11: {
      ima_termoizolaciju: true,
    },
    _20_1: {
      ima_termoizolaciju: false,
    },
    _20_2: {
      ima_termoizolaciju: false,
    },
    _20_3: {
      ima_termoizolaciju: false,
    },
    _20_4: {
      ima_termoizolaciju: true,
    },
    _21_1: {
      ima_termoizolaciju: false,
    },
    _21_2: {
      ima_termoizolaciju: false,
    },
    _21_3: {
      ima_termoizolaciju: false,
    },
    _21_4: {
      ima_termoizolaciju: true,
    },
  },
  materijali: {
    1: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-fit-plus",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    2: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-fit-g-plus",
      dimenzija: "625X1000",
      cena: null,
      image: "",
    },
    3: {
      web: "https://www.knaufinsulation.rs/proizvodi/df",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    4: {
      web: "https://www.knaufinsulation.rs/proizvodi/fkd-s-thermal",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    5: {
      web: "https://www.knaufinsulation.rs/proizvodi/fkd-n-thermal",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    6: {
      web: "https://www.knaufinsulation.rs/proizvodi/smartroof-thermal",
      dimenzija: "1200x2000",
      cena: null,
      image: "",
    },
    7: {
      web: "https://www.knaufinsulation.rs/proizvodi/smartroof-thermal-2",
      dimenzija: "1200x2000",
      cena: null,
      image: "",
    },
    8: {
      web: "https://www.knaufinsulation.rs/proizvodi/smartroof-top",
      dimenzija: "1200x2000",
      cena: null,
      image: "",
    },
    9: {
      web: "https://www.knaufinsulation.rs/proizvodi/unifit-035",
      dimenzija: 1200,
      cena: null,
      image: "",
    },
    10: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-002",
      dimenzija: "1,5 x 50",
      cena: null,
      image: "",
    },
    11: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-5",
      dimenzija: "1,5 x 50",
      cena: null,
      image: "",
    },
    12: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-35",
      dimenzija: "1,5 x 50",
      cena: null,
      image: "",
    },
    13: {
      web: "https://www.knaufinsulation.rs/proizvodi/pod-plus",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    14: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-pod-extra",
      dimenzija: "600X1000",
      cena: null,
      image: "",
    },
    15: {
      web: "https://www.knaufinsulation.gr/proionta/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_101.png"),
    },
    16: {
      web: "https://www.knaufinsulation.gr/proionta/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_102.png"),
    },
    17: {
      web: "https://www.knaufinsulation.gr/proionta/smartroof-top",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_103.png"),
    },
    18: {
      web: "https://www.knaufinsulation.gr/proionta/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_104.png"),
    },
    19: {
      web: "https://www.knaufinsulation.gr/proionta/homeseal-lds-35-membrane-elegchoy-ydratmon",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_105.png"),
    },
    20: {
      web: "https://www.knaufinsulation.gr/proionta/naturoll-plus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_106.png"),
    },
    21: {
      web: "https://www.knaufinsulation.gr/proionta/rolla-chorismaton-ultracoustic-ypseles-echoaporropheses",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_107.png"),
    },
    22: {
      web: "https://www.knaufinsulation.gr/remote_product/3855",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_108.png"),
    },
    23: {
      web: "https://www.knaufinsulation.gr/remote_product/3857",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_109.png"),
    },
    24: {
      web: "https://www.knaufinsulation.gr/proionta/ultracoustic-p-plakes-horismaton-ypsilis-ihoaporrofisis",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_113.png"),
    },
    25: {
      web: "https://www.knaufinsulation.gr/remote_product/3856",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_110.png"),
    },
    26: {
      web: "https://www.knaufinsulation.gr/proionta/naturboard-pod-standard",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_111.png"),
    },
    27: {
      web: "https://www.knaufinsulation.gr/proionta/naturboard-pod-extra",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_112.png"),
    },
    28: {
      web: "https://www.knaufinsulation.ro/produse/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_205.png"),
    },
    29: {
      web: "https://www.knaufinsulation.ro/produse/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_204.png"),
    },
    30: {
      web: "https://www.knaufinsulation.ro/produse/smartroof-top",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_215.png"),
    },
    31: {
      web: "https://www.knaufinsulation.ro/produse/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    32: {
      web: "https://www.knaufinsulation.ro/produse/smartroof-norm",
      dimenzija: null,
      cena: null,
      image: "",
    },
    33: {
      web: "https://www.knaufinsulation.ro/produse/homeseal-lds-35",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_208.png"),
    },
    34: {
      web: "https://www.knaufinsulation.ro/produse/naturboard-fit-plus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_210.png"),
    },
    35: {
      web: "https://www.knaufinsulation.ro/produse/homeseal-lds-002",
      dimenzija: null,
      cena: null,
      image: "",
    },
    36: {
      web: "https://www.knaufinsulation.ro/produse/homeseal-lds-5",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_207.png"),
    },
    37: {
      web: "https://www.knaufinsulation.ro/products/df",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_203.png"),
    },
    38: {
      web: "https://www.knaufinsulation.ro/produse/naturboard-pod-standard",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_213.png"),
    },
    39: {
      web: "https://www.knaufinsulation.ro/produse/naturboard-pod-extra",
      dimenzija: null,
      cena: null,
      image: "",
    },
    40: {
      web: "https://www.knaufinsulation.ro/produse/mpn-plus-037",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_209.png"),
    },
    41: {
      web: "https://www.knaufinsulation.ro/produse/unifit-035",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_216.png"),
    },
    42: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_401.png"),
    },
    43: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_401.png"),
    },
    44: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/smartwall-n-c1",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_402.png"),
    },
    45: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/fkl",
      dimenzija: null,
      cena: null,
      image: "",
    },
    46: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/smartroof-top",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_403.png"),
    },
    47: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    48: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/ddp-x",
      dimenzija: null,
      cena: null,
      image: "",
    },
    49: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/homeseal-lds-200-aluplus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    50: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/termotop",
      dimenzija: null,
      cena: null,
      image: "",
    },
    51: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/homeseal-lds-004-fixplus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_411.png"),
    },
    52: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturboard-fit-g",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_404.png"),
    },
    53: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/akustik-board",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_405.png"),
    },
    54: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/homeseal-lds-100-aluplus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_406.png"),
    },
    55: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturoll-plus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_407.png"),
    },
    56: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/unifit-035",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_410.png"),
    },
    57: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturboard-fit",
      dimenzija: null,
      cena: null,
      image: "",
    },
    58: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/homeseal-lds-35",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_409.png"),
    },
    59: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/homeseal-lds-36",
      dimenzija: null,
      cena: null,
      image: "",
    },
    60: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturboard-kp",
      dimenzija: null,
      cena: null,
      image: "",
    },
    61: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturboard-tp",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_408.png"),
    },
    62: {
      web: "https://www.knaufinsulation.hr/proizvodi-0/naturboard-tpt",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_408.png"),
    },
    63: {
      web: "https://www.knaufinsulation.hr/proizvodi/naturboard-partition",
      dimenzija: null,
      cena: null,
      image: "",
    },
    64: {
      web: "https://www.knaufinsulation.cz/produkty/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    65: {
      web: "https://www.knaufinsulation.cz/produkty/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    66: {
      web: "https://www.knaufinsulation.cz/produkty/smartroof-top",
      dimenzija: null,
      cena: null,
      image: "",
    },
    67: {
      web: "https://www.knaufinsulation.cz/produkty/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    68: {
      web: "https://www.knaufinsulation.cz/produkty/smartroof-norm",
      dimenzija: null,
      cena: null,
      image: "",
    },
    69: {
      web: "https://www.knaufinsulation.cz/produkty/homeseal-lds-100",
      dimenzija: null,
      cena: null,
      image: "",
    },
    70: {
      web: "https://www.knaufinsulation.cz/produkty/unifit-035",
      dimenzija: null,
      cena: null,
      image: "",
    },
    71: {
      web: "https://www.knaufinsulation.cz/produkty/homeseal-lds-002-uv-fixplus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    72: {
      web: "https://www.knaufinsulation.cz/produkty/homeseal-lds-2",
      dimenzija: null,
      cena: null,
      image: "",
    },
    73: {
      web: "https://www.knaufinsulation.cz/produkty/pte",
      dimenzija: null,
      cena: null,
      image: "",
    },
    74: {
      web: "https://www.knaufinsulation.cz/produkty/pts",
      dimenzija: null,
      cena: null,
      image: "",
    },
    75: {
      web: "https://www.knaufinsulation.cz/produkty/akustik-board",
      dimenzija: null,
      cena: null,
      image: "",
    },
    76: {
      web: "https://www.knaufinsulation.cz/produkty/naturoll-pro",
      dimenzija: null,
      cena: null,
      image: "",
    },
    77: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/smartwall-fkd-s-c1",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_701.png"),
    },
    78: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-fkd-s",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_702.png"),
    },
    79: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    80: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-ddp",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_703.png"),
    },
    81: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-ddp-k",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_703.png"),
    },
    82: {
      web: "http://www.knaufinsulation.sk/homeseal-lds-40",
      dimenzija: null,
      cena: null,
      image: "",
    },
    83: {
      web: "http://www.knaufinsulation.sk/lds-100",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_704.png"),
    },
    84: {
      web: "http://www.knaufinsulation.sk/sklena-vlna/unifit-037-ti-137-u",
      dimenzija: null,
      cena: null,
      image: "",
    },
    85: {
      web: "http://www.knaufinsulation.sk/lds/homeseal-lds-002-uv",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_705.png"),
    },
    86: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-pte",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_706.png"),
    },
    87: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-mpe",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_707.png"),
    },
    88: {
      web: "http://www.knaufinsulation.sk/kamenna-vlna/nobasil-mpn",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_707.png"),
    },
    89: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    90: {
      web: "https://www.knaufinsulation.sk/produkty/unifit-035",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_708.png"),
    },
    91: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    92: {
      web: "https://www.knaufinsulation.bg/produkti/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    93: {
      web: "https://www.knaufinsulation.bg/produkti/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    94: {
      web: "https://www.knaufinsulation.bg/produkti/smartroof-top",
      dimenzija: null,
      cena: null,
      image: "",
    },
    95: {
      web: "https://www.knaufinsulation.bg/produkti/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    96: {
      web: "https://www.knaufinsulation.bg/produkti/smartroof-base",
      dimenzija: null,
      cena: null,
      image: "",
    },
    97: {
      web: "https://www.knaufinsulation.bg/produkti/homeseal-lds-35",
      dimenzija: null,
      cena: null,
      image: "",
    },
    98: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-fit-plus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    99: {
      web: "https://www.knaufinsulation.bg/produkti/homeseal-lds-002",
      dimenzija: null,
      cena: null,
      image: "",
    },
    100: {
      web: "https://www.knaufinsulation.bg/produkti/homeseal-lds-5",
      dimenzija: null,
      cena: null,
      image: "",
    },
    101: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-pod-standard",
      dimenzija: null,
      cena: null,
      image: "",
    },
    102: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-pod-extra",
      dimenzija: null,
      cena: null,
      image: "",
    },
    103: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-fit",
      dimenzija: null,
      cena: null,
      image: "",
    },
    104: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-ventacusto",
      dimenzija: null,
      cena: null,
      image: "",
    },
    105: {
      web: "https://www.knaufinsulation.bg/produkti/akustik-board",
      dimenzija: null,
      cena: null,
      image: "",
    },
    106: {
      web: "https://www.knaufinsulation.bg/produkti/akustik-roll",
      dimenzija: null,
      cena: null,
      image: "",
    },
    107: {
      web: "https://www.knaufinsulation.bg/produkti/naturboard-venti",
      dimenzija: null,
      cena: null,
      image: "",
    },
    108: {
      web: "https://www.knaufinsulation.bg/produkti/unifit-035",
      dimenzija: null,
      cena: null,
      image: "",
    },
    109: {
      web: "https://www.knaufinsulation.bg/produkti/unifit-037",
      dimenzija: null,
      cena: null,
      image: "",
    },
    110: {
      web: "https://www.knaufinsulation.si/proizvodi/fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    111: {
      web: "https://www.knaufinsulation.si/proizvodi/smartwall-n-c1",
      dimenzija: null,
      cena: null,
      image: "",
    },
    112: {
      web: "https://www.knaufinsulation.si/proizvodi/smartroof-top",
      dimenzija: null,
      cena: null,
      image: "",
    },
    113: {
      web: "https://www.knaufinsulation.si/proizvodi/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    114: {
      web: "https://www.knaufinsulation.si/proizvodi/unifit-035",
      dimenzija: null,
      cena: null,
      image: "",
    },
    115: {
      web: "https://www.knaufinsulation.si/proizvodi/homeseal-lds-004-fixplus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    116: {
      web: "https://www.knaufinsulation.si/proizvodi/homeseal-lds-5",
      dimenzija: null,
      cena: null,
      image: "",
    },
    117: {
      web: "https://www.knaufinsulation.si/proizvodi/pohodna-talna-plosca-df",
      dimenzija: null,
      cena: null,
      image: "",
    },
    118: {
      web: "https://www.knaufinsulation.si/proizvodi/homeseal-lds-100",
      dimenzija: null,
      cena: null,
      image: "",
    },
    119: {
      web: "https://www.knaufinsulation.si/proizvodi/naturboard-tps",
      dimenzija: null,
      cena: null,
      image: "",
    },
    120: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-pod-standard",
      dimenzija: null,
      cena: null,
      image: "",
    },
    121: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-pod-extra",
      dimenzija: null,
      cena: null,
      image: "",
    },
    122: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-35",
      dimenzija: null,
      cena: null,
      image: "",
    },
    123: {
      web: "https://www.knaufinsulation.si/proizvodi/naturboard-tpt",
      dimenzija: null,
      cena: null,
      image: "",
    },
    124: {
      web: "https://www.knaufinsulation.si/proizvodi/naturboard-venti",
      dimenzija: null,
      cena: null,
      image: "",
    },
    125: {
      web: "https://www.knaufinsulation.si/proizvodi/naturboard-df",
      dimenzija: null,
      cena: null,
      image: "",
    },
    126: {
      web: "https://www.knaufinsulation.rs/proizvodi/naturboard-fit-g-plus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    127: {
      web: "https://www.knaufinsulation.si/proizvodi/decibel",
      dimenzija: null,
      cena: null,
      image: "",
    },
    128: {
      web: "https://www.knaufinsulation.hu/termekek/smartroof-top",
      dimenzija: null,
      cena: null,
      image: "",
    },
    129: {
      web: "https://www.knaufinsulation.hu/termekek/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    139: {
      web: "https://www.knaufinsulation.hu/termekek/unifit-035",
      dimenzija: null,
      cena: null,
      image: "",
    },
    140: {
      web: "https://www.knaufinsulation.hu/termekek/cf-fkd-s-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    141: {
      web: "https://www.knaufinsulation.hu/termekek/fkd-n-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    142: {
      web: "https://www.knaufinsulation.ro/produse/smartroof-base",
      dimenzija: null,
      cena: null,
      image: "",
    },
    143: {
      web: "https://www.knaufinsulation.pl/produkty/unifit-035-0",
      dimenzija: null,
      cena: null,
      image: "",
    },
    144: {
      web: "https://www.knaufinsulation.pl/produkty/unifit-033-0",
      dimenzija: null,
      cena: null,
      image: "",
    },
    145: {
      web: "https://www.knaufinsulation.pl/remote_product/2885",
      dimenzija: null,
      cena: null,
      image: "",
    },
    146: {
      web: "https://www.knaufinsulation.pl/remote_product/3509",
      dimenzija: null,
      cena: null,
      image: "",
    },
    147: {
      web: "https://www.knaufinsulation.pl/remote_product/2888",
      dimenzija: null,
      cena: null,
      image: "",
    },
    148: {
      web: "https://www.knaufinsulation.pl/remote_product/2889",
      dimenzija: null,
      cena: null,
      image: "",
    },
    149: {
      web: "https://www.knaufinsulation.pl/produkty/homeseal-lds-004",
      dimenzija: null,
      cena: null,
      image: "",
    },
    150: {
      web: "https://www.knaufinsulation.pl/produkty/homeseal-lds-2",
      dimenzija: null,
      cena: null,
      image: "",
    },
    151: {
      web: "https://www.knaufinsulation.pl/produkty/homeseal-lds-35-fixplus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    152: {
      web: "https://www.knaufinsulation.pl/remote_product/4355",
      dimenzija: null,
      cena: null,
      image: "",
    },
    153: {
      web: "https://www.knaufinsulation.pl/produkty/homeseal-lds-40",
      dimenzija: null,
      cena: null,
      image: "",
    },
    154: {
      web: "https://www.knaufinsulation.ro/produse/akustik-board",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_201.png"),
    },
    155: {
      web: "https://www.knaufinsulation.ro/produse/naturoll-plus-alu",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_202.png"),
    },
    156: {
      web: "https://www.knaufinsulation.ro/produse/fkl-thermal",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_206.png"),
    },
    157: {
      web: "https://www.knaufinsulation.ro/produse/naturboard-fit-plus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_211.png"),
    },
    158: {
      web: "https://www.knaufinsulation.ro/produse/naturboard-venti",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_212.png"),
    },
    159: {
      web: "https://www.knaufinsulation.ro/produse/naturoll-plus",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_214.png"),
    },
    160: {
      web: "https://www.knaufinsulation.ro/remote_product/3792",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_217.png"),
    },
    161: {
      web: "https://www.knaufinsulation.pl/produkty/out-therm",
      dimenzija: null,
      cena: null,
      image: "",
    },
    162: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    163: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    164: {
      web: "https://www.knaufinsulation.pl/produkty/smartroof-top",
      dimenzija: null,
      cena: null,
      image: "",
    },
    165: {
      web: "https://www.knaufinsulation.pl/produkty/smartroof-thermal",
      dimenzija: null,
      cena: null,
      image: "",
    },
    166: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    167: {
      web: "https://www.knaufinsulation.pl/remote_product/3378",
      dimenzija: null,
      cena: null,
      image: "",
    },
    168: {
      web: "https://www.knaufinsulation.pl/remote_product/3505",
      dimenzija: null,
      cena: null,
      image: "",
    },
    169: {
      web: "https://www.knaufinsulation.pl/remote_product/3506",
      dimenzija: null,
      cena: null,
      image: "",
    },
    170: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    171: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    172: {
      web: "https://www.knaufinsulation.pl/",
      dimenzija: null,
      cena: null,
      image: "",
    },
    173: {
      web: "https://www.knaufinsulation.hu/termekek/naturboard-0-37-tp-116",
      dimenzija: null,
      cena: null,
      image: "",
    },
    174: {
      web: "https://www.knaufinsulation.hu/termekek/ptn",
      dimenzija: null,
      cena: null,
      image: "",
    },
    175: {
      web: "https://www.knaufinsulation.hu/termekek/pts",
      dimenzija: null,
      cena: null,
      image: "",
    },
    176: {
      web: "https://www.knaufinsulation.hu/remote_product/3387",
      dimenzija: null,
      cena: null,
      image: "",
    },
    177: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-35",
      dimenzija: null,
      cena: null,
      image: "",
    },
    178: {
      web: "https://www.knaufinsulation.hu/termekek/naturboard-0-37-tp-116",
      dimenzija: null,
      cena: null,
      image: "",
    },
    179: {
      web: "www.knaufinsulation.rs/proizvodi/homeseal-lds-002",
      dimenzija: null,
      cena: null,
      image: "",
    },
    180: {
      web: "https://www.knaufinsulation.rs/proizvodi/homeseal-lds-5",
      dimenzija: null,
      cena: null,
      image: "",
    },
    181: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    182: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    183: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    184: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    185: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    186: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    187: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    188: {
      web: "https://www.knaufinsulation.com.tr/remote_product/4682",
      dimenzija: null,
      cena: null,
      image: "",
    },
    189: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    190: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    191: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    192: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    193: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    194: {
      web: null,
      dimenzija: null,
      cena: null,
      image: "",
    },
    195: {
      web: "https://www.knaufinsulation.sk/produkty/unifit-033",
      dimenzija: null,
      cena: null,
      image: "",
    },
    196: {
      web: "https://www.knaufinsulation.sk/produkty/homeseal-lds-002-uv-fixplus",
      dimenzija: null,
      cena: null,
      image: "",
    },
    197: {
      web: "www.knaufinsulation.sk/produkty/homeseal-lds-2",
      dimenzija: null,
      cena: null,
      image: "",
    },
    198: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-ipb-037",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_603.png"),
    },
    199: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-ipb-039",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_603.png"),
    },
    200: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb-034-0",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    201: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb034-kd",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    202: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb033-extra",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    203: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb033-extra-kd",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    204: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb032-pro",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    205: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/mineral-plus-fcb032-pro-kd",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_602.png"),
    },
    206: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/earthwool-043-0",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_601.png"),
    },
    207: {
      web: "https://www.knaufinsulation.com.tr/urunler-0/earthwool-043-alu",
      dimenzija: null,
      cena: null,
      image: require("../src/assets/images/materijali/mat_601.png"),
    },
  },
};
